import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConditionalMatIconComponent } from './conditional-mat-icon.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [ConditionalMatIconComponent],
    imports: [
        CommonModule,
        MatIconModule,
    ],
    exports: [
        ConditionalMatIconComponent
    ]
})
export class ConditionalMatIconModule {
}
